import {
  getGroupMemberIds,
  getTextBackgroundCardTextId,
  isTextBackgroundCardGroup,
} from './annotationGroupUtils';

/** Konva transformer nodes: include every member when selection touches a group. */
export const expandSelectionIdsForTransformer = (selectionsIds = [], annotations = {}) => {
  const expanded = new Set();

  selectionsIds.forEach((id) => {
    if (!annotations[id]) {
      return;
    }
    const { groupId } = annotations[id];
    if (groupId && isTextBackgroundCardGroup(annotations, groupId)) {
      const textId = getTextBackgroundCardTextId(annotations, groupId);
      expanded.add(textId || id);
      return;
    }
    if (groupId) {
      getGroupMemberIds(annotations, id).forEach((memberId) => expanded.add(memberId));
    } else {
      expanded.add(id);
    }
  });

  return [...expanded];
};

export default expandSelectionIdsForTransformer;
